import React, { useEffect, useState, useMemo, memo } from "react";
import { financialCalculations, processQuote } from '../../../../utils/sharedFunctions.js'
import { TextInput } from "../../../../components/index.js";
import "./style.scss";


const formatCash = (number) =>
  new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number || 0);

const formatDate = (dateString) => {
  if (!dateString) return 'YYYY/MM/DD';
  const date = new Date(dateString);
  return isNaN(date.getTime()) ? 'YYYY/MM/DD' : date.toISOString().split('T')[0];
};

const calculateDurationInDays = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  return Math.ceil(Math.abs(end - start) / (1000 * 60 * 60 * 24)) || 0;
};

const TableHeader = memo(({ headers }) => (
  <div className="headerdiv">
    {headers.map((header, index) => (
      <p key={index} className="purple_text">{header}</p>
    ))}
  </div>
));

const PriceRow = memo(({ label, amount, isTotal = false, width = "85%", fontWeight, color }) => (
  <div className="contentdiv" style={{ height: '1dvh' }}>
    <p className={`${isTotal ? 'purple_text' : 'greytext'}`} style={{ width }}>
      {label}
    </p>
    <p className="purple_text" style={{ fontWeight: fontWeight ?? '300', color: color ?? '' }}>
      {`ZAR ${formatCash(amount)}`}
    </p>
  </div>
));

const ProjectQuoteInvoice = memo(({ Brief, SelectedPro, isEditProjectPlan, getUpdated }) => {
  const [projectPlan, setProjectPlan] = useState([]);
  const [quote, setQuote] = useState([]);
  const [TotalDeliverableCost, setTotalDeliverableCost] = useState(0);
  const [ModBrief, setModBrief] = useState(Brief);
  const Finances = financialCalculations(TotalDeliverableCost, Brief);

  useEffect(() => {
    const deliverables = Brief?.projectPlan?.[0]?.deliverables;
    if (deliverables) setProjectPlan(deliverables);
  }, [Brief]);

  useEffect(() => {
    const processedQuote = processQuote(Brief, SelectedPro);
    const validBillables = processedQuote.validBillables;

    setTotalDeliverableCost(processedQuote.totalPayable);
    setQuote(validBillables);
  }, [Brief, SelectedPro]);

  function handlePlanChange(e, item) {
    let brief = { ...Brief };
    const ID = e.currentTarget.id;
    const VALUE = e.target.value;

    const updatedProjectPlan = projectPlan.map(planItem => {
      if (planItem === item) {
        switch (ID) {
          case 'name': return { ...planItem, nameOfItem: VALUE };
          case 'strt': return { ...planItem, disStartDate: VALUE };
          case 'end': return { ...planItem, disEndDate: VALUE };
          case 'revision': return { ...planItem, reverts: parseInt(VALUE) || 0 };
          default: return planItem;
        }
      }
      return planItem;
    });
    brief.projectPlan[0].deliverables = updatedProjectPlan;
    setProjectPlan(updatedProjectPlan);
    setModBrief(brief);
    getUpdated(brief);
  }

  return (
    <div className="project-quote-invoice">
      <div className="the_parent" style={{ marginBottom: '3.5%' }}>
        <p className="purple_text" style={{ fontSize: '16px', margin: '5px 0' }}>Plan</p>
        <div className="greydiv">
          <TableHeader headers={['Item(s)', 'Start Date', 'End Date', 'Duration', 'Revisions Allowed']} />
          {!isEditProjectPlan && projectPlan.map((item, index) => (
            <div className="contentdiv" style={{ marginBottom: '1%' }} key={index}>
              <p className="greytext">{item.nameOfItem || ''}</p>
              <p className="greytext">{formatDate(item.disStartDate)}</p>
              <p className="greytext">{formatDate(item.disEndDate)}</p>
              <p className="greytext">
                {calculateDurationInDays(item.disStartDate, item.disEndDate)} Days
              </p>
              <p className="purple_text" style={{ fontWeight: '300' }}>
                {item.reverts || 0}
              </p>
            </div>
          ))}

          {isEditProjectPlan && projectPlan.map((item, index) => (

            <div className="contentdiv" style={{ marginBottom: '1%' }} key={index}>
              <TextInput onChange={(e) => handlePlanChange(e, item)} id='name' className="greytext" value={item.nameOfItem ?? ''} />
              <TextInput onChange={(e) => handlePlanChange(e, item)} id='strt' className="greytext" type='date' value={formatDate(item.disStartDate)} />
              <TextInput onChange={(e) => handlePlanChange(e, item)} id='end' className="greytext" type='date' value={formatDate(item.disEndDate)} />
              <p className="greytext">{calculateDurationInDays(item.disStartDate, item.disEndDate)} Days </p>
              <TextInput onChange={(e) => handlePlanChange(e, item)} id='revision' className="purple_text" style={{ fontWeight: '300' }} value={item.reverts ?? 0} />
            </div>
          ))}
        </div>

      </div>

      <div className="the_parent">
        <p className="purple_text" style={{ fontSize: '16px', margin: '5px 0' }}>
          Quote for Project
        </p>
        <div className="greydiv">
          <TableHeader headers={['Name', 'Qty(Items)', 'Unit Price', 'Amount']} />
          {quote.map((item, index) => (
            <div className="contentdiv" style={{ marginBottom: '2%' }} key={index}>
              <p className="greytext">{item.itemName || ''}</p>
              <p className="greytext">{item.quantity || 0}</p>
              <p className="greytext">{`ZAR ${formatCash(item.unitPrice)}`}</p>
              <p className="purple_text" style={{ fontWeight: '300' }}>
                {`ZAR ${formatCash(item.unitPrice * item.quantity)}`}
              </p>
            </div>
          ))}

          <div className="headerdiv">
            <p className="purple_text">Professional Service fee</p>
            <p className="purple_text">{`ZAR ${formatCash(TotalDeliverableCost)}`}</p>
          </div>

          {quote.length > 0 && (
            <div className="contentdiv" style={{ marginBottom: '0.5%', flexDirection: 'column' }}>
              <PriceRow label="Credipple platform fee (10%)" amount={Finances.CredFee10} />
              {/* <PriceRow label="Subtotal" amount={0} /> */}
              {/* <PriceRow label="VAT(15%)" amount={VAT} /> */}
            </div>
          )}

          <PriceRow label="Total amount payable To Professional" amount={TotalDeliverableCost <=0?'':Finances.TotAmtPay2Prof} isTotal={true} width="80%" fontWeight="bold" />

          {typeof Brief.tempVoucherObj === 'object' && Brief.tempVoucherObj?.sponsorAmount > 0 && (
            <>
              <div className="headerdiv">
                <p className="purple_text" style={{ width: '80%', margin: '1.5% 0%' }}>
                  Amount to be invoiced to Voucher Sponsor
                </p>
              </div>
              {quote.length > 0 &&
                <div className="contentdiv" style={{ marginBottom: '0.5%', flexDirection: 'column' }}>
                  <PriceRow label="Voucher Amount Debited" amount={Finances.voucherAmntDebited} />
                  <PriceRow label="Professional Service Fee" amount={TotalDeliverableCost} />
                  <PriceRow label="Credipple platform fee (15%)" amount={Finances.CredFee15} />
                  <PriceRow label="Subtotal" amount={Finances.SponsorSubTot} />
                  <PriceRow label="VAT(15%)" amount={(Finances.SponsorSubTot) * 0.15} />
                </div>
              }

              <PriceRow label="Total amount payable by sponsor" amount={(Finances.SponsorSubTot) * 0.15 + (Finances.SponsorSubTot)} isTotal={true} width="80%" fontWeight="bold" />
            </>
          )}

          <div className="headerdiv">
            <p className="purple_text" style={{ width: '80%', margin: '1.5% 0%' }}>
              Amount To Be Paid By Client
            </p>
          </div>
          {quote.length > 0 &&
            <div className="contentdiv" style={{ marginBottom: '0.5%', flexDirection: 'column' }}>
              <PriceRow label="Credipple platform fee (10%)" amount={TotalDeliverableCost < 2500 ? 250 : Finances.Remaining2BPayByClient * 0.1} />
              <PriceRow label="Subtotal" amount={TotalDeliverableCost < 2500 ? TotalDeliverableCost + 250 : Finances.ClientSubTot} />
              <PriceRow label="VAT(15%)" amount={TotalDeliverableCost < 2500 ? (TotalDeliverableCost + 250) * 0.15 : Finances.ClientSubTot * 0.15} />
            </div>
          }

          <PriceRow label="Total amount payable by Client" amount={TotalDeliverableCost < 2500 ? (TotalDeliverableCost + 250) * 0.15 + (TotalDeliverableCost + 250) :
            Finances.ClientSubTot * 0.15 + (Finances.ClientSubTot)} isTotal={true} width="80%" fontWeight="bold" color={0} />
        </div>
      </div>
    </div>
  );
});

ProjectQuoteInvoice.displayName = 'ProjectQuoteInvoice';
export default ProjectQuoteInvoice;